































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const ApplicationStore = namespace('application');

@Component({})
export default class TermsAndConditionsDialogComponent extends Vue {

    @ApplicationStore.Getter('termsAndConditionsDialog')
    private _termsAndConditionsDialog!: boolean;

    get termsAndConditionsDialog(): boolean {
        return this._termsAndConditionsDialog;
    }

    get termsAndConditionsLink(): string {
        return process.env.VUE_APP_TERMS_AND_CONDITIONS_LINK!;
    }
}
